"use client";

import React from "react";

import type { LabelInputProps } from "@/types";

import * as S from "./styles";

const LabelInput: React.FC<LabelInputProps> = ({
  labelInput,
  className,
  children,
  labelDescription,
  htmlFor,
}) => {
  return (
    <S.LabelInputComponent htmlFor={htmlFor} className={className}>
      {labelInput}
      {labelDescription && (
        <S.DescriptionLabel>{labelDescription}</S.DescriptionLabel>
      )}
      {children}
    </S.LabelInputComponent>
  );
};

export default LabelInput;
